/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface UpdateCustomerRequest { 
    code?: string;
    firstName?: string;
    lastName?: string;
    codeExternal?: string;
    sex?: UpdateCustomerRequest.SexEnum;
    birthDate?: string;
    country?: string;
    birthCountry?: string;
    countryNationality?: string;
    city?: number;
    birthCity?: number;
    postalCode?: string;
    address?: string;
    telephone?: string;
    mobile?: string;
    email?: string;
    pep?: boolean;
    status?: UpdateCustomerRequest.StatusEnum;
    watched?: UpdateCustomerRequest.WatchedEnum;
    occupation?: string;
}
export namespace UpdateCustomerRequest {
    export type SexEnum = 'Male' | 'Female';
    export const SexEnum = {
        Male: 'Male' as SexEnum,
        Female: 'Female' as SexEnum
    };
    export type StatusEnum = 'Active' | 'Unactive' | 'Blocked' | 'Unblocked';
    export const StatusEnum = {
        Active: 'Active' as StatusEnum,
        Unactive: 'Unactive' as StatusEnum,
        Blocked: 'Blocked' as StatusEnum,
        Unblocked: 'Unblocked' as StatusEnum
    };
    export type WatchedEnum = 'Watched' | 'Unwatched';
    export const WatchedEnum = {
        Watched: 'Watched' as WatchedEnum,
        Unwatched: 'Unwatched' as WatchedEnum
    };
}
